<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data">
        <div class="data-title flex-space-between" slot="header">
          <p>Video Tracks Scan</p>
          <div class="float-right">
            <Filters/>
            <el-tooltip content="Report" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-document"
                @click="generateReport()"
                class="ml10"
              ></el-button>
            </el-tooltip>
          </div>
        </div>
        <el-tabs type="border-card">
          <el-tab-pane label="Regular Paid Videos">
            <RegularVideos :artist_credited="artist_credited"/>
          </el-tab-pane>
          <el-tab-pane label="Free Videos">
            <FreeVideos :artist_credited="artist_credited" />
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import RegularVideos from '../components/video-tracks-scan/RegularVideos'
import ShortVideos from '../components/video-tracks-scan/ShortVideos'
import FreeVideos from '@/modules/admin/vidcents/components/video-tracks-scan/FreeVideos'
import Filters from '../components/video-tracks-scan/Filters'
import { mapState, mapActions } from 'vuex'
import store from "../../../../plugins/vuex";

export default {

  data() {
    return {
      artist_credited: [
        'Shout Out','Video Overlay','Nothing'
      ],
    }
  },
  components: {
    RegularVideos,
    ShortVideos,
    Filters,
    FreeVideos
  },

  computed: {
    ...mapState('vcVideoTracksScanRegular', ['loading']),
    level3: function() {
      if (store.state.auth.user.permission === 3) return true
      else {
        return false
      }
    }
  },

  methods: {
    ...mapActions('vcVideoTracksScanRegular', ['generateReport'])
  }
}
</script>
